import { type ReactNode } from 'react';

import { Flex } from 'components/Flex';
import { Header } from 'modules/application/components/Header';

import classes from './Layout.module.scss';

interface Props {
  children: ReactNode;
}

export function Layout(props: Props) {
  return (
    <Flex className={classes.Layout} column full>
      <Header />
      <main className={classes.main}>{props.children}</main>
    </Flex>
  );
}
